import { render } from "./TableauBordPage.vue?vue&type=template&id=1015b770&ts=true"
import script from "./TableauBordPage.vue?vue&type=script&lang=ts"
export * from "./TableauBordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__